import React from 'react';
import { LoadingContainer } from './Loading.styled';
import { Box, Center, Cover, Spinner } from '@thecb/components';

const Loading = () => (
  <LoadingContainer data-testid="loading">
    <Cover singleChild>
      <Box>
        <Cover minHeight="100%" singleChild>
          <Center intrinsic>
            <Box>
              <Spinner size="100" />
            </Box>
          </Center>
        </Cover>
      </Box>
    </Cover>
  </LoadingContainer>
);

export default Loading;
